import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { DadosGerais } from '../shared/model';

@Injectable({
  providedIn: 'root'
})

export class DadosGeraisService {

  private readonly endpoint = '/sepin-backend/rest/dados-gerais-empresa/';

  constructor(private readonly http: McticHttpClient) {
  }

  obterDadosGerais() {
    return this.http.get<DadosGerais>(this.endpoint);
  }

  salvarDadosGerais(dadosGerais: DadosGerais) {
    return this.http.post(this.endpoint, dadosGerais);
  }
}
